import services from "../services";

const messages = Object.values(services).filter((item) => item.messages);
const en = messages.reduce(function(result, item) {
  return { ...result, [item.messages.id]: item.messages.en };
}, {});
const ru = messages.reduce(function(result, item) {
  return { ...result, [item.messages.id]: item.messages.ru };
}, {});

export default {
  en: {
    title: "Сервисы программы Airalab",
    menu: {
      services: "сервисы",
    },
    services: {
      title: "Сервисы программы Airalab",
      provider: "Провайдер",
      token: "Платежный токен",
    },
    approve: {
      allowance: "Одобрено",
      approve: "Одобрить",
      cost: "Стоимость",
      balance: "Баланс",
    },
    steps: {
      broadcast: "Вещаем сообщение.",
      responded: "Сервис ответил на спрос.",
      contract: "Создан умный контракт, мы ждем, что робот выполнит услугу.",
      tx: "	Провайдер Робономики отправил транзакцию в Ethereum.",
      view_lighthouse: "Посмотреть маяк.",
      view_contract: "Посмотреть договор.",
      executed: "Умный контракт выполнен!",
    },
    ...en,
  },
  ru: {
    title: "Сервисы программы Airalab",
    menu: {
      services: "сервисы",
    },
    services: {
      title: "Сервисы программы Airalab",
      provider: "Провайдер",
      token: "Платежный токен",
    },
    approve: {
      allowance: "Одобрено",
      approve: "Одобрить",
      cost: "Стоимость",
      balance: "Баланс",
    },
    steps: {
      broadcast: "Вещаем сообщение.",
      responded: "Сервис ответил на спрос.",
      contract: "Создан умный контракт, мы ждем, что робот выполнит услугу.",
      tx: "	Провайдер Робономики отправил транзакцию в Ethereum.",
      view_lighthouse: "Посмотреть маяк.",
      view_contract: "Посмотреть договор.",
      executed: "Умный контракт выполнен!",
    },
    ...ru,
  },
};
